import type { ChatThread } from '../model/types';

const GENERIC_THREAD_TITLES = new Set(['Group chat', 'Direct chat']);

function isGenericThreadTitle(title: string): boolean {
  return GENERIC_THREAD_TITLES.has(title.trim());
}

export function mergeThreadWithExisting(prev: ChatThread, next: ChatThread): ChatThread {
  const title =
    prev.title && isGenericThreadTitle(next.title) && !isGenericThreadTitle(prev.title)
      ? prev.title
      : next.title;

  return {
    ...next,
    title,
    avatarUrl: next.avatarUrl ?? prev.avatarUrl,
    pinnedMessage: prev.pinnedMessage ?? next.pinnedMessage,
    peerUserId: next.peerUserId ?? prev.peerUserId,
    online: next.online ?? prev.online,
    lastSeenAt: next.lastSeenAt !== undefined ? next.lastSeenAt : prev.lastSeenAt,
    lastSeenLabel: next.lastSeenLabel ?? prev.lastSeenLabel,
  };
}
